var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeVectorRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 224,
    viewBox: "0 0 170 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M348.53 151.928C73.9651 273.251 -130.959 210.048 108.239 164.579C22.0351 158.622 -42.4235 57.1048 40.5557 1.61689",
    stroke: "#413FE5",
    strokeWidth: 3.41966,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeVectorRight);
export default __webpack_public_path__ + "static/media/home-vector-right.e9defa422a7aebe80ffb9b264212f6df.svg";
export { ForwardRef as ReactComponent };